import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslateModule, TranslatePipe } from '@ngx-translate/core'
import { AppLoadingComponent } from '@src/app/shared/components/app-loading/app-loading.component.js'
import { CheckboxComponent } from '@src/app/shared/components/checkbox/checkbox.component.js'
import { PasswordIndicatorComponent } from '@src/app/shared/components/password-indicator/password-indicator.component.js'
import { ProgressIndicatorComponent } from '@src/app/shared/components/progress-indicator/progress-indicator.component.js'
import { RadioIconComponent } from '@src/app/shared/components/radio-icon/radio-icon.component.js'
import { SpinnerComponent } from '@src/app/shared/components/spinner/spinner.component.js'
import { TutorialBoxComponent } from '@src/app/shared/components/tutorial-box/tutorial-box.component.js'
import { UserDetailsComponent } from '@src/app/shared/components/user-details/user-details.component.js'
import { MdPipe } from '@src/app/shared/pipes/md.pipe.js'
import { AppleAuthDirective } from './directives/apple-auth.directive.js'
import { DatoImageDirective } from './directives/dato-image.directive.js'
import { ExperimentableImageDirective } from './directives/editable-image.directive.js'
import { GhostDirective } from './directives/ghost.directive.js'
import { GoogleAuthDirective } from './directives/google-auth.directive.js'
import { MarkdownDirective } from './directives/markdown.directive.js'
import { MixpanelEventDirective } from './directives/mixpanel-event.directive.js'
import { SensitiveDirective } from './directives/sensitive.directive.js'
import { TrackDirective } from './directives/track.directive.js'
import { DiscountPipe } from './pipes/discount.pipe.js'
import { LocalizePipe } from './pipes/localize.pipe.js'
import { MarkdownPipe } from './pipes/markdown.pipe.js'
import { SafePipe } from './pipes/safe.pipe.js'
import { StripTagsPipe } from './pipes/strip-tags.pipe.js'

@NgModule({
  declarations: [
    GhostDirective,
    SensitiveDirective,
    TrackDirective,
    SpinnerComponent,
    MixpanelEventDirective,
    MarkdownDirective,
    MarkdownPipe,
    MdPipe,
    LocalizePipe,
    DiscountPipe,
    StripTagsPipe,
    CheckboxComponent,
    PasswordIndicatorComponent,
    UserDetailsComponent,
    ProgressIndicatorComponent,
    AppLoadingComponent,
    RadioIconComponent,
    GoogleAuthDirective,
    AppleAuthDirective,
    SafePipe,
    TutorialBoxComponent,
    DatoImageDirective,
  ],
  imports: [RouterModule, CommonModule, TranslateModule, ExperimentableImageDirective],
  exports: [
    GhostDirective,
    SensitiveDirective,
    TrackDirective,
    SpinnerComponent,
    MixpanelEventDirective,
    MarkdownDirective,
    MarkdownPipe,
    MdPipe,
    LocalizePipe,
    DiscountPipe,
    StripTagsPipe,
    CheckboxComponent,
    PasswordIndicatorComponent,
    UserDetailsComponent,
    ProgressIndicatorComponent,
    AppLoadingComponent,
    RadioIconComponent,
    TranslatePipe,
    GoogleAuthDirective,
    AppleAuthDirective,
    SafePipe,
    TutorialBoxComponent,
    ExperimentableImageDirective,
    DatoImageDirective,
  ],
  providers: [DiscountPipe, LocalizePipe],
})
export class SharedModule {}
